<template>
  <div class="installment">
    <v-list-view name="分期" right-icon="arrow-right-v3" @click="changePopupStatus">
      <ul>
        <li
          class="right-content-item"
          v-if="stagingInfo && !env.isBankabc"
          v-track="[
            {
              act: 'show',
              params: { cfrom: '176|001|02|077', event_id: '176|001|02|077', page_name: pageName, sku_id: skuId }
            },
            {
              act: 'click',
              params: { cfrom: '176|001|01|077', event_id: '176|001|01|077', page_name: pageName, sku_id: skuId }
            }
          ]"
        >
          <div class="item" v-if="installment.optimalText">
            <div class="item-title">{{ installment.optimalText }}</div>
          </div>
          <div class="item-desc" v-html="stagingInfo"></div>
        </li>
      </ul>
    </v-list-view>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import env from '@/utils/clientEnv'

export default {
  name: 'Installment',
  data() {
    return {
      env
    }
  },
  computed: {
    ...mapState('detailv3', ['installment']),
    ...mapGetters('detailv3', ['stagingInfo', 'skuId', 'discountType']),
    // 埋点参数page_name
    pageName() {
      return this.discountType == 'group' ? 2 : 1
    }
  },
  methods: {
    ...mapActions('detailv3', ['changeInstallmentPopupStatus', 'savePreFocusElByEvent']),
    changePopupStatus(e) {
      this.changeInstallmentPopupStatus(true)
      this.savePreFocusElByEvent(e)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .item-desc {
    height: auto;
  }
}
</style>
